import { BaseQuantity } from "../../interface/functionalityInterface";
// Copy of length
export const SurfaceFinish: BaseQuantity = {
  id: "001surfaceFinish",
  name: "surface_finish",
  type: "text",
  value: "",
  symbol: "\u03B5",
  baseUnit: "m",
  selectedUnit: "\u00b5m",
  units: [
    { name: "\u00b5m", fromConst: 1 / 10 ** 6, toConst: 10 ** 6 },
    { name: "mm", fromConst: 1 / 1000, toConst: 1000 },
    { name: "m", fromConst: 1, toConst: 1 },
  ],
};
